import React from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@material-ui/core'
import { DATE_FORMAT } from '../constants'
import { FormattedMessage } from 'react-intl'
import { makeStyles } from '@material-ui/core/styles'
import CloseIcon from '@material-ui/icons/Close'
import EditIcon from '@material-ui/icons/Edit'
import DeleteOutlineOutlinedIcon from '@material-ui/icons/DeleteOutlineOutlined'
import moment from 'moment'

const useStyles = makeStyles((theme) => ({
  dialogWrapper: {
    '& .MuiDialog-paper': {
      maxWidth: 660,
    },
  },
  titleSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: '29px 30px 0px 43px',
  },
  titleWrapper: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  closeBtn: {
    cursor: 'pointer',
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
    color: '#404040',
  },
  contentSection: {
    display: 'flex',
    flexDirection: 'column',
    padding: '29px 30px 13px 43px',
    color: '#404040',
    wordWrap: 'break-word',
  },
  footerSection: {
    padding: '12px 43px  29px',
  },
  titleSectionActions: {
    display: 'flex',
  },
  titleSectionAction: {
    marginRight: 10,
    color: '#0073b1',
    cursor: 'pointer',
  },
  footerWrapper: {
    display: 'flex',
    width: '100%',
    color: '#0073b1',
    paddingTop: 13,
    borderTop: 'solid 1px #70707042',
  },
  footerTitle: {
    fontWeight: 'bold',
    marginRight: 22,
  },
}))

export default (props) => {
  const {
    note,
    openOrCloseDetailsDialog,
    openOrCloseEditDialog,
    openOrCloseDeleteDialog,
  } = props
  const styleClass = useStyles()

  return (
    <Dialog
      maxWidth="md"
      fullWidth={true}
      className={styleClass.dialogWrapper}
      open={true}
    >
      <DialogTitle disableTypography={true} className={styleClass.titleSection}>
        <div className={styleClass.titleWrapper}>
          <div>
            <div className={styleClass.title}>
              <FormattedMessage id="note.details.title" />
            </div>
          </div>

          <div className={styleClass.titleSectionActions}>
            <span
              className={styleClass.titleSectionAction}
              onClick={() => {
                openOrCloseEditDialog(note)
              }}
            >
              <EditIcon />
            </span>
            <span
              className={styleClass.titleSectionAction}
              onClick={() => {
                openOrCloseDeleteDialog(note.id)
              }}
            >
              <DeleteOutlineOutlinedIcon />
            </span>
            <div
              className={styleClass.closeBtn}
              onClick={openOrCloseDetailsDialog}
            >
              <CloseIcon />
            </div>
          </div>
        </div>
      </DialogTitle>

      <DialogContent className={styleClass.contentSection}>
        {note.text}
      </DialogContent>

      <DialogActions className={styleClass.footerSection}>
        <div className={styleClass.footerWrapper}>
          <span className={styleClass.footerTitle}>{note.createdBy.name}</span>
          <span>{moment(note.createdAt).format(DATE_FORMAT)}</span>
        </div>
      </DialogActions>
    </Dialog>
  )
}
